import { render } from "./ProductosRefrigerados.vue?vue&type=template&id=76de4561"
import script from "./ProductosRefrigerados.vue?vue&type=script&lang=js"
export * from "./ProductosRefrigerados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__